function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_20",
  "data-name": "Grupo 20"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_19",
  "data-name": "Grupo 19"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_23",
  "data-name": "Ret\\xE2ngulo 23",
  width: 8,
  height: 8,
  transform: "translate(49.646 48.646)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1",
  "data-name": "Caminho 1",
  d: "M94.719,8.382H89.689V0H81.307V8.382H25.985V0H17.6V8.382H12.573A12.588,12.588,0,0,0,0,20.955V94.719a12.588,12.588,0,0,0,12.573,12.573H55.692a36.963,36.963,0,0,1-7.473-8.382H12.573a4.2,4.2,0,0,1-4.191-4.191V39.4H98.91v8.822a36.972,36.972,0,0,1,8.382,7.473V20.955A12.588,12.588,0,0,0,94.719,8.382ZM98.91,31.014H8.382V20.955a4.2,4.2,0,0,1,4.191-4.191H17.6v8.382h8.382V16.764H81.307v8.382h8.382V16.764h5.029a4.2,4.2,0,0,1,4.191,4.191Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2",
  "data-name": "Caminho 2",
  d: "M270.29,242a28.29,28.29,0,1,0,28.29,28.29A28.322,28.322,0,0,0,270.29,242Zm0,48.2A19.908,19.908,0,1,1,290.2,270.29,19.93,19.93,0,0,1,270.29,290.2Z",
  transform: "translate(-191.288 -191.288)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_3",
  "data-name": "Caminho 3",
  d: "M364.382,310H356v18.231h15.507v-8.382h-7.125Z",
  transform: "translate(-281.399 -245.038)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_24",
  "data-name": "Ret\\xE2ngulo 24",
  width: 8,
  height: 9,
  transform: "translate(32.646 64.646)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_25",
  "data-name": "Ret\\xE2ngulo 25",
  width: 9,
  height: 9,
  transform: "translate(15.646 64.646)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_26",
  "data-name": "Ret\\xE2ngulo 26",
  width: 9,
  height: 8,
  transform: "translate(15.646 48.646)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_27",
  "data-name": "Ret\\xE2ngulo 27",
  width: 9,
  height: 8,
  transform: "translate(15.646 81.646)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_28",
  "data-name": "Ret\\xE2ngulo 28",
  width: 8,
  height: 8,
  transform: "translate(32.646 48.646)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_29",
  "data-name": "Ret\\xE2ngulo 29",
  width: 8,
  height: 8,
  transform: "translate(32.646 81.646)",
  fill: "#fff"
})));

const SvgIconCalendar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "icon-calendar",
  width: 107.292,
  height: 107.292,
  viewBox: "0 0 107.292 107.292",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-calendar.8994504a.svg";
export { ForwardRef as ReactComponent };